import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const UserBadge = ({ user, noLink, size }) => {
  const me = useSelector((state) => state.user);
  let initials =
    (user?.firstname?.charAt(0) ?? "?") + (user?.lastname?.charAt(0) ?? "?");
  let isMe = user?.id === me?.id;
  let profile_media = user?.profile_media;
  let link = user.athlete_id ? `/athletes/${user.athlete_id}` : null;
  if (!noLink && link) {
    return (
      <Link
        to={link}
        className={`user-badge ${size ? `user-badge-${size}` : ``} badge bg-${
          isMe ? "primary" : "success"
        } p-0`}
      >
        {profile_media ? (
          <img src={profile_media?.url} alt={user?.firstname} />
        ) : (
          initials.toUpperCase()
        )}
      </Link>
    );
  } else {
    return (
      <div
        className={`user-badge ${size ? `user-badge-${size}` : ``} badge bg-${
          isMe ? "primary" : "success"
        } p-0`}
      >
        {profile_media ? (
          <img src={profile_media?.url} alt={user?.firstname} />
        ) : (
          initials.toUpperCase()
        )}
      </div>
    );
  }
};
